import type { SearchVehicleTemplatesParams } from './vehicle-template.api';

export const vehicleTemplateKeys = {
  all: ['vehicle-templates'] as const,
  list: (params: SearchVehicleTemplatesParams): readonly unknown[] => [...vehicleTemplateKeys.lists(), params] as const,
  lists: (): readonly string[] => [...vehicleTemplateKeys.all, 'list'] as const,
};
